import React from "react";
import { WorkOrderWithAppointments } from "@myapp/contract";
import { useInfiniteScrollSentinel } from "../../../../shared/hooks/useInfiniteScrollSentinel";
import Loader from "../../../../shared/ui/feedback/Loader/Loader";
import { WorkOrderListItem } from "./WorkOrderListItem";

interface WorkOrderListViewProps {
  items: WorkOrderWithAppointments[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
}

export const WorkOrderListView: React.FC<WorkOrderListViewProps> = ({
  items,
  isLoading,
  isFetchingNextPage,
  hasMore,
  onLoadMore,
}) => {
  const sentinelRef = useInfiniteScrollSentinel({ hasMore, onLoadMore });

  if (isLoading && !items.length) {
    return (
      <div className="my-10 flex w-full justify-center">
        <Loader />
      </div>
    );
  }

  if (!items.length) {
    return (
      <p className="my-10 w-full text-center font-['PT_Sans'] text-[20px] font-bold text-primary">
        Keine Aufträge für die aktuellen Filter.
      </p>
    );
  }

  return (
    <div className="flex w-full flex-col gap-2 md:gap-4">
      {items.map((item) => (
        <WorkOrderListItem
          key={`${item.external.auftragJahr}-${item.external.auftragNr}`}
          item={item}
        />
      ))}
      {hasMore && <div ref={sentinelRef} className="h-1" />}
      {isFetchingNextPage && (
        <div className="my-4 flex w-full justify-center">
          <Loader size="small" />
        </div>
      )}
    </div>
  );
};
